export const validateFormFields = {
    methods: {
        validateFormFields(form) {
            let success = true
            for (const [key, val] of Object.entries(form)) {
                const value = val.value
                if (!val.required) continue
                if (value === null || value === undefined) {
                    form[key].invalid = val.errorMessage
                        ? val.errorMessage
                        : 'To pole nie może być puste'
                    success = false
                } else {
                    form[key].invalid = ''
                }
                if (typeof value === 'string' || typeof value === 'undefined') {
                    if (value === '') {
                        form[key].invalid = val.errorMessage
                            ? val.errorMessage
                            : 'To pole nie może być puste'
                        success = false
                    } else {
                        form[key].invalid = ''
                    }
                }
                if (Array.isArray(value)) {
                    if (!value.length) {
                        form[key].invalid = val.errorMessage
                            ? val.errorMessage
                            : 'To pole nie może być puste'
                        success = false
                    } else {
                        form[key].invalid = ''
                    }
                }
                if (typeof value === 'boolean') {
                    if (!value) {
                        form[key].invalid = val.errorMessage
                            ? val.errorMessage
                            : 'To pole nie może być puste'
                        success = false
                    } else {
                        form[key].invalid = ''
                    }
                }
            }
            return success
        }
    }
}
